import { render, staticRenderFns } from "./DiagnosticCard.vue?vue&type=template&id=068063b9&scoped=true"
import script from "./DiagnosticCard.vue?vue&type=script&lang=js"
export * from "./DiagnosticCard.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticCard.vue?vue&type=style&index=0&id=068063b9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068063b9",
  null
  
)

export default component.exports